/* Sheets. Rooms and search share one wiring. */
function wireSheet({ panel, open, close, onOpen }) {
  const sheet = document.querySelector(panel);
  if (!sheet) return;
  let lastTrigger = null;

  const shut = () => {
    if (!sheet.classList.contains("is-open")) return;
    sheet.classList.remove("is-open");
    lastTrigger?.focus();
  };

  for (const btn of document.querySelectorAll(open)) {
    btn.addEventListener("click", (ev) => {
      ev.preventDefault();
      lastTrigger = btn;
      sheet.classList.add("is-open");
      onOpen?.(sheet);
    });
  }
  for (const btn of sheet.querySelectorAll(close)) {
    btn.addEventListener("click", shut);
  }
  sheet.addEventListener("click", (ev) => {
    if (ev.target === sheet) shut();
  });
  document.addEventListener("keydown", (ev) => {
    if (ev.key === "Escape") shut();
  });
}

wireSheet({
  panel: "[data-rooms]",
  open: "[data-open-rooms]",
  close: "[data-close-rooms]",
});

wireSheet({
  panel: "[data-sonar]",
  open: "[data-open-sonar]",
  close: "[data-close-sonar]",
  onOpen: (sheet) => {
    window.dispatchEvent(new Event("vault:sonar"));
    sheet.querySelector("[data-sonar-input]")?.focus();
  },
});

/* PASTE-DOWN. Cards carry data-settle; each one gets pressed onto the board as
   it scrolls into view. The hidden state in vault.craft.css only applies once
   data-js is stamped here, so a blocked script costs the entrance, never the
   cards. Rows enter together, so a small per-batch delay staggers them. */
const reduceMotion = document.documentElement.getAttribute("data-motion") === "reduce";
const settlers = document.querySelectorAll("[data-settle]");
if (settlers.length && !reduceMotion && "IntersectionObserver" in window) {
  document.documentElement.setAttribute("data-js", "");
  const io = new IntersectionObserver(
    (entries) => {
      let batch = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.style.transitionDelay = `${Math.min(batch++, 5) * 55}ms`;
        entry.target.classList.add("is-settled");
        io.unobserve(entry.target);
      }
    },
    { rootMargin: "0px 0px -6% 0px", threshold: 0.05 },
  );
  for (const el of settlers) io.observe(el);
}

/* THE DAY COUNT CANNOT GO STALE. "Next find in N days" is computed at render
   time, and a cached page keeps saying it. The rule is the same one the Liquid
   uses — weeks tick on a day-of-year boundary — so the label is recomputed
   here on load and again whenever the tab comes back from the background.
   Day granularity only: the shop's own invitation promises no countdown
   timers, and it keeps that promise. */
const drop = document.querySelector("[data-drop]");
if (drop) {
  const paintDrop = () => {
    const now = new Date();
    const daynum = Math.floor((now - new Date(now.getFullYear(), 0, 0)) / 86400000);
    const into = (daynum - 1) % 7;
    const left = 7 - into;
    const text =
      into === 0
        ? drop.getAttribute("data-next-today")
        : left === 1
          ? drop.getAttribute("data-next-one")
          : (drop.getAttribute("data-next-many") || "").replace("%d", String(left));
    if (text) drop.textContent = text;
  };
  paintDrop();
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) paintDrop();
  });
}
